/**
 * Onboarding Module Types
 * 
 * Type definitions for the onboarding carousel system.
 */

/**
 * A single onboarding slide
 */
export interface OnboardingSlide {
  /** Unique identifier for the slide */
  id: string;
  /** Main title of the slide */
  title: string;
  /** Description/body text */
  description: string;
  /** Lottie animation source (require statement) */
  lottieSource: any;
  /** Optional icon name (Ionicons) */
  icon?: string;
  /** Optional background color */
  backgroundColor?: string;
}

/**
 * Onboarding type for tracking different onboarding flows
 */
export type OnboardingType = "user" | "admin";

/**
 * Onboarding status from database
 */
export interface OnboardingStatus {
  /** Whether the user has completed onboarding */
  completed: boolean;
  /** Timestamp when onboarding was completed */
  completedAt: string | null;
}

